import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';

export class Ploom2 {

    age: any;
    segment: any;
    endgame: boolean;
    answerQuestion1Value: any;
    answerQuestion2Value: any;
    answerQuestion3Value: any;
    answerQuestion4Value: any;

    questionGateAge: Question;
    disclaimer1: Question;
    disclaimer2: Question;
    disclaimer3: Question;
    question1: Question;
    question2: Question;
    question3: Question;
    question4: Question;
    question5: Question;
    question6: Question;
    question7: Question;
    question8: Question;
    question9: Question;
    question10: Question;
    question11: Question;
    question12: Question;
    question13: Question;
    question14: Question;
    question15: Question;
    question16: Question;
    question17: Question;
    question18: Question;
    question19: Question;
    question20: Question;
    question21: Question;
    question22: Question;
    question23: Question;
    question24: Question;
    question25: Question;
    question26: Question;
    question27: Question;
    question28: Question;
    question29: Question;
    question30a: Question;
    question30b: Question;
    question31: Question;
    question32: Question;
    question33: Question;
    // question34: Question;
    // question35: Question;
    question36: Question;
    question37: Question;
    question38: Question;
    question39: Question;
    question40: Question;

    questions: Array<Question>;

    constructor(private applicationStorage: ApplicationStorage) {
        this.endgame = false;
        this.questionGateAge = new Question(1, [],
            'Te rugăm să confirmi că ai vârsta peste 18 ani:',
            '',
            'radio',
            [new Response(1, 'Da'),
            new Response(2, 'Nu'),
            ],
            false,
        );

        this.question1 = new Question(2, [1],  // 1a
            'Cât de des fumezi țigarete (țigarete convenționale, în pachet)?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Le-am folosit în mod regulat în trecut, dar nu le mai folosesc'),
            new Response(9, 'Nu am folosit niciodată'),
            new Response(10, 'Nu cunosc această categorie')],
            false
        );

        this.question1.render = () => {
            this.age = false;
            let questionAgeSelectedIds = this.questionGateAge.responses.filter(r => r.selected);
            if (questionAgeSelectedIds.length > 0) {
                if (questionAgeSelectedIds[0].id == 1) {
                    this.age = true;
                    this.endgame = false;
                    return true;
                } else {
                    this.endgame = true;
                }
                return false;
            }
            return false;
        }

        this.question2 = new Question(3, [2],//1b
            'Cât de des folosești dispozitive de încălzit tutunul sau alte produse din plante cu nicotină și rezerve dedicate?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Le-am folosit în mod regulat în trecut, dar nu le mai folosesc'),
            new Response(9, 'Nu am folosit niciodată'),
            new Response(10, 'Nu cunosc această categorie')],
            false
        );

        this.question2.render = () => {
            if (this.endgame == true) { return false; }
            let question1SelectedIds = this.question1.responses.filter(r => r.selected);
            if (question1SelectedIds.length > 0) {
                this.answerQuestion1Value = question1SelectedIds[0].id;
                return true;
            } else {
                this.answerQuestion1Value = undefined;
                this.answerQuestion2Value = undefined;
                this.answerQuestion3Value = undefined;
                this.answerQuestion4Value = undefined;
                return false;
            }
        }

        this.question3 = new Question(4, [3],//1c
            'Cât de des folosești țigarete electronice (de unică folosință, cu capsule sau rezervor)?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Le-am folosit în mod regulat în trecut, dar nu le mai folosesc'),
            new Response(9, 'Nu am folosit niciodată'),
            new Response(10, 'Nu cunosc această categorie')],
            false
        );

        this.question3.render = () => {
            // for (let q = 0; q < this.getQuestions().length; q++) {
            //     let question = this.questions[q];
            //     console.log('i: ', question.id, question);
            //     if (question.id > 4) {
            //         //resetam
            //         let element: HTMLInputElement = <HTMLInputElement>document.getElementById(question.id + "");
            //         console.log("element: ", element)
            //         if (question.type.startsWith('radio') || question.type.startsWith('checkbox')) {
            //             question.responses.filter(r => r.id).forEach(r => r.selected = false);
            //             this.responseChangedService.changedResponseEvent.emit(this.question.id);


            //         }

            //     }
            //     //let questionDesc = this.getQuestions().filter(q => q.id === questionId)[0];

            // }
            // let questionId = 4;
            // let questionDesc = this.getQuestions().filter(q => q.id === questionId)[0];
            // let element: HTMLInputElement = <HTMLInputElement>document.getElementById(questionId + "");
            // console.log("questionDesc: ", questionDesc)
            // console.log("element: ", element)
            if (this.endgame == true) { return false; }
            let question2SelectedIds = this.question2.responses.filter(r => r.selected);
            if (question2SelectedIds.length > 0) {
                this.answerQuestion2Value = question2SelectedIds[0].id;
                return true;
            } else {
                this.answerQuestion1Value = undefined;
                this.answerQuestion2Value = undefined;
                this.answerQuestion3Value = undefined;
                this.answerQuestion4Value = undefined;
                return false;
            }



        }

        this.question4 = new Question(5, [4],//1d
            'Cât de des folosești tutun rulat?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Le-am folosit în mod regulat în trecut, dar nu le mai folosesc'),
            new Response(9, 'Nu am folosit niciodată'),
            new Response(10, 'Nu cunosc această categorie')],
            false
        );

        this.question4.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(r => r.selected);
            if (question3SelectedIds.length > 0) {
                this.answerQuestion3Value = question3SelectedIds[0].id;
                return true;
            } else {
                this.answerQuestion1Value = undefined;
                this.answerQuestion2Value = undefined;
                this.answerQuestion3Value = undefined;
                this.answerQuestion4Value = undefined;
                return false;
            }
        }

        this.disclaimer1 = new Question(6, [2, 3, 4, 5],//stop joc
            'Te-ai înregistrat și ți-ai exprimat acordul pentru participare la studii de piață cu ocazia achiziției de pe site-ul Ploom, din magazine partenere, prin înregistrare ulterioară sau ca urmare a discuției cu o ambasadoare de brand și a achiziției Ploom, dispozitiv care încălzește rezerve cu tutun. Astfel, apari în baza noastră de date și ai primit acest chestionar de evaluare a experienței Ploom. Dacă este o eroare, te rugăm să te dezabonezi prin accesarea link-ului de dezabonare din mesajul e-mail primit sau să consulți serviciul de asistență clienți la numărul 0800 008 811, de luni până vineri, între 8:00 - 22:00, sâmbătă și duminică, între 10:00 - 18:00.',
            '',
            'empty-box',
            [],
            false
        );

        this.disclaimer1.render = () => {
            if (this.endgame == true) { return false; }
            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            if (question4SelectedIds.length > 0) {
                this.answerQuestion4Value = question4SelectedIds[0].id;
                this.getFlow(this.answerQuestion1Value, this.answerQuestion2Value, this.answerQuestion3Value, this.answerQuestion4Value);
                //return this.question1.responses.filter(rsp => rsp.id === 1)[0].selected;
                if (this.segment == 'STOP') {
                    this.endgame = true;
                    return true;
                } else {
                    this.endgame = false;
                }
                return false;
            } else { return false; }
        }

        this.question5 = new Question(7, [2, 3, 4, 5],//2a
            'Câte țigarete fumezi, în medie, pe zi?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question5.render = () => {
            if (this.endgame == true) { return false; }
            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            if (question4SelectedIds.length > 0) {
                this.answerQuestion4Value = question4SelectedIds[0].id;
                this.getFlow(this.answerQuestion1Value, this.answerQuestion2Value, this.answerQuestion3Value, this.answerQuestion4Value);
                //return this.question1.responses.filter(rsp => rsp.id === 1)[0].selected;
                if (this.segment == 'FLOW1' || this.segment == 'FLOW3') {
                    if (this.answerQuestion1Value == 1) {
                        return true;
                    } else {
                        return false
                    }
                } else {
                    return false;
                }
            } else { return false; }
        }

        this.question6 = new Question(7999, [2, 3, 4, 5], //2b
            'Câte țigarete fumezi, în medie, pe săptămână?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question6.render = () => {
            if (this.endgame == true) { return false; }
            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            if (question4SelectedIds.length > 0) {
                this.answerQuestion4Value = question4SelectedIds[0].id;
                this.getFlow(this.answerQuestion1Value, this.answerQuestion2Value, this.answerQuestion3Value, this.answerQuestion4Value);

                if (this.segment == 'FLOW1' || this.segment == 'FLOW3') {
                    if (this.answerQuestion1Value == 2 || this.answerQuestion1Value == 3) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else { return false; }
        }

        this.question7 = new Question(8, [2, 3, 4, 5],//2c
            'Câte țigarete fumezi, în medie, pe lună?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question7.render = () => {
            if (this.endgame == true) { return false; }
            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            if (question4SelectedIds.length > 0) {
                this.answerQuestion4Value = question4SelectedIds[0].id;
                this.getFlow(this.answerQuestion1Value, this.answerQuestion2Value, this.answerQuestion3Value, this.answerQuestion4Value);
                if (this.segment == 'FLOW1' || this.segment == 'FLOW3') {
                    if (this.answerQuestion1Value == 4 || this.answerQuestion1Value == 5 || this.answerQuestion1Value == 6) {
                        return true;
                    } else {
                        return false
                    }
                } else {
                    return false;
                }
            } else { return false; }
        }

        this.question8 = new Question(9, [6, 7, 7999, 8], //3
            'Ce marcă de țigarete fumezi cel mai des?',
            'Alege o singură marcă',
            'dropdown',
            this.question8Responses,
            false
        );

        //this.question8.responses[133].render = (rsp: Response): boolean => { return false };

        this.question8.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment == 'FLOW1' || this.segment == 'FLOW3') {
                return true;
            } else {
                return false;
            }
        }

        this.question9 = new Question(10, [2, 3, 4, 5, 9],//4a
            'Care dintre următoarele mărci de dispozitive de încălzit tutunul sau alte produse din plante cu nicotină îți sunt cunoscute, indiferent dacă le-ai folosit sau nu?',
            'Bifează toate mărcile de dispozitive de care ai auzit',
            'checkbox',
            [new Response(1, 'glo'),
            new Response(2, 'iQOS (inclusiv Iluma)'),
            new Response(3, 'lil'),
            new Response(4, 'Ploom'),
            new Response(5, 'Niciuna')
            ],
            true
        );

        let question9ResponseRenderer = (rsp: Response): boolean => {
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                return false;
            } else {
                let question9SelectedTexts = this.question9.responses.filter(r => r.selected).map(r => r.id);
                if (question9SelectedTexts.length > 0) {
                    if (question9SelectedTexts.includes(5)) {
                        return true;
                    }
                    return false;
                }
                return true;
            }
        }

        this.question9.responses[4].render = question9ResponseRenderer;

        let question9ResponseRendererOther = (rsp: Response): boolean => {
            console.log(this.segment)
            // if (this.segment != 'FLOW3' && this.segment != 'STOP') {
            //     return false;
            // } else {
            let question9SelectedTexts = this.question9.responses.filter(r => r.selected).map(r => r.id);
            if (question9SelectedTexts.length > 0) {
                if (question9SelectedTexts.includes(5)) {
                    return false;
                }
                return true;
            }
            return true;
            // }
        }

        this.question9.responses[0].render = question9ResponseRendererOther;
        this.question9.responses[1].render = question9ResponseRendererOther;
        this.question9.responses[2].render = question9ResponseRendererOther;
        this.question9.responses[3].render = question9ResponseRendererOther;


        this.question9.render = () => {
            if (this.endgame == true) { return false; }
            if (this.getSegment()) {
                return true;
            }
            return false;
        }

        this.question10 = new Question(11, [10],//4b
            'Ești sigur/ă că nu ai auzit de Ploom (dispozitiv care încălzește rezerve cu tutun)?',
            '',
            'radio',
            [new Response(1, 'Sunt sigur/ă că NU am auzit de Ploom'),
            new Response(2, 'Da, am auzit de Ploom')
            ],
            false
        );

        this.question10.render = () => {
            if (this.endgame == true) { return false; }
            let question9SelectedTexts = this.question9.responses.filter(r => r.selected).map(r => r.text);
            return this.question9.responses.filter(r => r.selected).length > 0 && !question9SelectedTexts.includes('Ploom');
        }

        this.disclaimer2 = new Question(39, [10],//stop joc
            'Te-ai înregistrat și ți-ai exprimat acordul pentru participare la studii de piață cu ocazia achiziției de pe site-ul Ploom, din magazine partenere, prin înregistrare ulterioară sau ca urmare a discuției cu o ambasadoare de brand și a achiziției Ploom, dispozitiv care încălzește rezerve cu tutun. Astfel, apari în baza noastră de date și ai primit acest chestionar de evaluare a experienței Ploom. Dacă este o eroare, te rugăm să te dezabonezi prin accesarea link-ului de dezabonare din mesajul e-mail primit sau să consulți serviciul de asistență clienți la numărul 0800 008 811, de luni până vineri, între 8:00 - 22:00, sâmbătă și duminică, între 10:00 - 18:00.',
            '',
            'empty-box',
            [],
            false
        );

        this.disclaimer2.render = () => {
            if (this.endgame == true) { return false; }
            if (this.getSegment()) {
                let question10SelectedIds = this.question10.responses.filter(r => r.selected);
                if (question10SelectedIds.length > 0) {
                    if (this.question10.responses.filter(rsp => rsp.id !== 2)[0].selected) {
                        let question9SelectedTexts = this.question9.responses.filter(r => r.selected).map(r => r.text);
                        if (this.question9.responses.filter(r => r.selected).length > 0 && !question9SelectedTexts.includes('Ploom')) {
                            this.endgame = true;
                            return true;
                        }

                        this.endgame = false;

                    } else {
                        this.endgame = false;
                    }
                }
                return false;
            }
            return false;
        }

        this.question11 = new Question(12, [10, 11],//5
            'Ce mărci de dispozitive ai încercat vreodată?',
            'Bifează toate mărcile pe care le-ai încercat',
            'checkbox',
            [new Response(1, 'glo'),
            new Response(2, 'iQOS (inclusiv Iluma)'),
            new Response(3, 'lil'),
            new Response(4, 'Ploom'),
            new Response(5, 'Niciuna')
            ],
            false
        );

        let question11ResponseRenderer = (rsp: Response): boolean => {
            if (this.endgame == true) { return false; }
            let question9SelectedIds = this.question9.responses.filter(r => r.selected).map(r => r.id);
            return question9SelectedIds.indexOf(rsp.id) >= 0;
        }

        let questionPloomResponseRenderer = (rsp: Response): boolean => {
            let question9SelectedIds = this.question9.responses.filter(r => r.selected).map(r => r.id);
            return question9SelectedIds.indexOf(rsp.id) >= 0 || this.question10.responses.filter(rsp => rsp.id === 2)[0].selected;
        }

        this.question11.responses[0].render = question11ResponseRenderer;
        this.question11.responses[1].render = question11ResponseRenderer;
        this.question11.responses[2].render = question11ResponseRenderer;
        this.question11.responses[3].render = questionPloomResponseRenderer;

        let question11ResponseRendererNone = (rsp: Response): boolean => {

            if (this.segment != 'FLOW3') {
                return false;
            }
            return true;
        }
        this.question11.responses[4].render = question11ResponseRendererNone;

        this.question11.render = () => {
            if (this.endgame == true) { return false; }
            return this.question9.responses.filter(rsp => rsp.text === 'Ploom')[0].selected ||
                this.question10.responses.filter(rsp => rsp.id === 2)[0].selected;
        }

        this.disclaimer3 = new Question(39, [10],//stop joc
            'Te-ai înregistrat și ți-ai exprimat acordul pentru participare la studii de piață cu ocazia achiziției de pe site-ul Ploom, din magazine partenere, prin înregistrare ulterioară sau ca urmare a discuției cu o ambasadoare de brand și a achiziției Ploom, dispozitiv care încălzește rezerve cu tutun. Astfel, apari în baza noastră de date și ai primit acest chestionar de evaluare a experienței Ploom. Dacă este o eroare, te rugăm să te dezabonezi prin accesarea link-ului de dezabonare din mesajul e-mail primit sau să consulți serviciul de asistență clienți la numărul 0800 008 811, de luni până vineri, între 8:00 - 22:00, sâmbătă și duminică, între 10:00 - 18:00.',
            '',
            'empty-box',
            [],
            false
        );

        this.disclaimer3.render = () => {
            if (this.endgame == true) { return false; }
            if (this.getSegment()) {
                let question11SelectedIds = this.question11.responses.filter(r => r.selected);
                if (question11SelectedIds.length == 1) {
                    if (this.question11.responses.filter(rsp => rsp.id === 5)[0].selected) {
                        this.endgame = true;
                        return true;
                    } else {
                        this.endgame = false;
                    }
                    return false;
                }
                return false;
            }
            return false;
        }

        this.question12 = new Question(13, [12],//6a
            'Cât de des folosești glo?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false
        );

        //daca varianta este Niciuna -> stop joc
        this.question12.render = () => {
            if (this.endgame == true) { return false; }
            console.log("glo", this.segment)
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                return this.question11.responses.filter(rsp => rsp.text === 'glo')[0].selected;
            } else {
                return false;
            }
        }

        this.question13 = new Question(14, [12],//6b
            'Cât de des folosești iQOS (inclusiv Iluma)?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false
        );

        this.question13.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                return this.question11.responses.filter(rsp => rsp.text === 'iQOS (inclusiv Iluma)')[0].selected;
            } else { return false; }
        }


        this.question14 = new Question(15, [11],//6c
            'Cât de des folosești lil?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false
        );

        this.question14.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                return this.question11.responses.filter(rsp => rsp.text === 'lil')[0].selected;
            } else { return false; }
        }

        this.question15 = new Question(16, [11],//6d
            'Cât de des folosești Ploom?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O data pe săptămână'),
            new Response(4, 'De 2-3 ori pe lună'),
            new Response(5, 'O dată pe lună'),
            new Response(6, 'Mai rar de o dată pe lună'),
            new Response(7, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(8, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')
            ],
            false
        );

        this.question15.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                return this.question11.responses.filter(rsp => rsp.text === 'Ploom')[0].selected;
            } else { return false; }
        }

        this.question16 = new Question(17, [15, 14, 13, 12],
            'Pe care îl folosești cel mai des?',
            'Bifează o singură marcă',
            'radio',
            [new Response(1, 'glo'),
            new Response(2, 'iQOS (inclusiv Iluma)'),
            new Response(3, 'lil'),
            new Response(4, 'Ploom')],
            false
        );

        let question16ResponseRenderer = (rsp: Response): boolean => {
            let values = new Map();

            let questions = [this.question12, this.question13, this.question14, this.question15];
            for (const [id, row] of Object.entries(questions)) {
                let tmp = row.responses.filter(r => r.selected);

                if (tmp[0] != undefined) {
                    if (values.get(tmp[0].id) == undefined) {
                        values.set(tmp[0].id, new Map<string, string>())
                    }
                    values.get(tmp[0].id).set(row.id, row.id);
                }
            }
            let question16SelectedIds = [];
            if (values.size > 0) {
                //sort
                var mapAsc = new Map([...values.entries()].sort());

                for (let entry of mapAsc.entries()) {
                    if (entry[1].size > 1) {

                        for (let dupl of entry[1].entries()) {

                            switch (dupl[1]) {
                                case 13: {
                                    question16SelectedIds.push(1)
                                    break;
                                }
                                case 14: {
                                    question16SelectedIds.push(2)
                                    break;
                                }
                                case 15: {
                                    question16SelectedIds.push(3)
                                    break;
                                }
                                case 16: {
                                    question16SelectedIds.push(4)
                                    break;
                                }
                            }
                        }
                    }
                    break;
                }
            }
            return question16SelectedIds.indexOf(rsp.id) >= 0;

        }
        this.question16.responses[0].render = question16ResponseRenderer;
        this.question16.responses[1].render = question16ResponseRenderer;
        this.question16.responses[2].render = question16ResponseRenderer;
        this.question16.responses[3].render = question16ResponseRenderer;

        this.question16.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                if (question16ResponseRenderer(new Response(1, 'glo')) ||
                    question16ResponseRenderer(new Response(2, 'iQOS (inclusiv Iluma)')) ||
                    question16ResponseRenderer(new Response(1, 'lil')) ||
                    question16ResponseRenderer(new Response(1, 'Ploom'))) { return true; } else {
                    return false;
                }
            }
            return false;
        }

        this.question17 = new Question(18, [15, 14, 13, 12],//8a glo
            'Câte rezerve de glo concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe zi?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question17.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question12SelectedId = this.question12.responses.filter(r => r.selected);
                if (question12SelectedId.length > 0) {
                    if (question12SelectedId[0].id == 1) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question18 = new Question(19, [15, 14, 13, 12],//8a iqos
            'Câte rezerve de iQOS (inclusiv Iluma) concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe zi?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question18.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question13SelectedId = this.question13.responses.filter(r => r.selected);
                if (question13SelectedId.length > 0) {
                    if (question13SelectedId[0].id == 1) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question19 = new Question(20, [15, 14, 13, 12],//8a iqos
            'Câte rezerve de lil concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe zi?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question19.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question14SelectedId = this.question14.responses.filter(r => r.selected);
                if (question14SelectedId.length > 0) {
                    if (question14SelectedId[0].id == 1) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question20 = new Question(21, [15, 14, 13, 12],//8a iqos
            'Câte rezerve de Ploom concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe zi?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question20.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0) {
                    if (question15SelectedId[0].id == 1) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question21 = new Question(22, [15, 14, 13, 12],//8b glo
            'Câte rezerve de glo concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe săptămână?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question21.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question12SelectedId = this.question12.responses.filter(r => r.selected);
                if (question12SelectedId.length > 0) {
                    if (question12SelectedId[0].id == 2 || question12SelectedId[0].id == 3) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question22 = new Question(23, [15, 14, 13, 12],//8b iqos
            'Câte rezerve de iQOS (inclusiv Iluma) concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe săptămână?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question22.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question13SelectedId = this.question13.responses.filter(r => r.selected);
                if (question13SelectedId.length > 0) {
                    if (question13SelectedId[0].id == 2 || question13SelectedId[0].id == 3) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question23 = new Question(24, [15, 14, 13, 12],//8b lil
            'Câte rezerve de lil concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe săptămână?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question23.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question14SelectedId = this.question14.responses.filter(r => r.selected);
                if (question14SelectedId.length > 0) {
                    if (question14SelectedId[0].id == 2 || question14SelectedId[0].id == 3) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question24 = new Question(25, [15, 14, 13, 12],//8b ploom
            'Câte rezerve de Ploom concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe săptămână?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question24.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0) {
                    if (question15SelectedId[0].id == 2 || question15SelectedId[0].id == 3) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question25 = new Question(26, [15, 14, 13, 12],//8c glo
            'Câte rezerve de glo concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe lună?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question25.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question12SelectedId = this.question12.responses.filter(r => r.selected);
                if (question12SelectedId.length > 0) {
                    if (question12SelectedId[0].id >= 4 && question12SelectedId[0].id <= 6) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question26 = new Question(27, [15, 14, 13, 12],//8c iqos
            'Câte rezerve de iQOS (inclusiv Iluma) concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe lună?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question26.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question13SelectedId = this.question13.responses.filter(r => r.selected);
                if (question13SelectedId.length > 0) {
                    if (question13SelectedId[0].id >= 4 && question13SelectedId[0].id <= 6) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question27 = new Question(28, [15, 14, 13, 12],//8c lil
            'Câte rezerve de lil concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe lună?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question27.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question14SelectedId = this.question14.responses.filter(r => r.selected);
                if (question14SelectedId.length > 0) {
                    if (question14SelectedId[0].id >= 4 && question14SelectedId[0].id <= 6) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question28 = new Question(29, [15, 14, 13, 12],//8c ploom
            'Câte rezerve de Ploom concepute pentru dispozitive de încălzit tutunul sau alte produse din plante cu nicotină folosești, în medie, pe lună?',
            '',
            'free-number-label',
            [new Response(1, '')],
            false
        );

        this.question28.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0) {
                    if (question15SelectedId[0].id >= 4 && question15SelectedId[0].id <= 6) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question29 = new Question(30, [15],//9a ploom
            'Ce sortiment(e) Sobranie sticks folosești cel mai des?',
            'În cazul în care folosești 2 sau mai multe sortimente diferite cu aceeași frecvență, bifează-le pe toate',
            'checkbox',
            [new Response(1, "Sobranie Bronze Sticks"),
            new Response(2, "Sobranie Tan Sticks"),
            new Response(3, "Sobranie Gold Sticks"),
            new Response(4, "Sobranie Teal Sticks"),
            new Response(5, "Sobranie Silver Sticks"),
            new Response(6, "Sobranie Yellow Sticks"),
            new Response(7, "Sobranie Garnet Sticks")],
            false
        );

        this.question29.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {

                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0) {
                    if (question15SelectedId[0].id >= 1 && question15SelectedId[0].id <= 6) {
                        return true;
                    }
                }

                return false;
            }
            return false;
        }

        this.question30a = new Question(31, [15],//9b ploom
            'Ce sortiment(e) Sobranie sticks ai încercat?',
            'În cazul în care ai încercat 2 sau mai multe sortimente diferite, bifează-le pe toate ',
            'checkbox',
            [new Response(1, "Sobranie Bronze Sticks"),
            new Response(2, "Sobranie Tan Sticks"),
            new Response(3, "Sobranie Gold Sticks"),
            new Response(4, "Sobranie Teal Sticks"),
            new Response(5, "Sobranie Silver Sticks"),
            new Response(6, "Sobranie Yellow Sticks"),
            new Response(7, "Sobranie Garnet Sticks"),
            new Response(8, 'Nu îmi amintesc')],
            false
        );

        this.question30a.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0 && (this.segment == 'FLOW1' || this.segment == 'FLOW2')) {
                    if (question15SelectedId[0].id >= 7 && question15SelectedId[0].id <= 8) {
                        return true;
                    }
                    return false;
                }


                return false;
            }
            return false;
        }

        this.question30b = new Question(40, [12],//9b ploom
            'Ce sortiment(e) Sobranie sticks ai încercat?',
            'În cazul în care ai încercat 2 sau mai multe sortimente diferite, bifează-le pe toate ',
            'checkbox',
            [new Response(1, "Sobranie Bronze Sticks"),
            new Response(2, "Sobranie Tan Sticks"),
            new Response(3, "Sobranie Gold Sticks"),
            new Response(4, "Sobranie Teal Sticks"),
            new Response(5, "Sobranie Silver Sticks"),
            new Response(6, "Sobranie Yellow Sticks (new)"),
            new Response(7, "Sobranie Garnet Sticks (new)"),
            new Response(8, 'Nu îmi amintesc')],
            false
        );

        this.question30b.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'STOP') {

                let question11SelectedId = this.question11.responses.filter(r => r.selected);
                if (question11SelectedId.length > 0 && this.segment == 'FLOW3') {
                    let question11SelectedTexts = this.question11.responses.filter(r => r.selected).map(r => r.text);
                    if (question11SelectedTexts.includes('Ploom')) {
                        return true;
                    }
                    return false;
                }
                return false;
            }
            return false;
        }

        this.question31 = new Question(32, [15],//10 ploom
            'De cât timp folosești Ploom?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1-2 luni'),
            new Response(3, '3-4 luni'),
            new Response(4, '5-6 luni')],
            false
        );

        this.question31.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0) {
                    if (question15SelectedId[0].id >= 1 && question15SelectedId[0].id <= 6) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question32 = new Question(33, [15],//11 ploom
            'Cât de mulțumit/ă ești de experiența Ploom și Sobranie sticks?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(5, 'Extrem de mulțumit/ă'),
            new Response(4, 'Mulțumit /ă'),
            new Response(3, 'Neutru'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(1, 'Foarte nemulțumit/ă'),],
            false
        );

        this.question32.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0) {
                    if (question15SelectedId[0].id >= 1 && question15SelectedId[0].id <= 6) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question33 = new Question(34, [15, 11],//12 ploom
            'Cât timp ai folosit Ploom și Sobranie sticks?',
            'Bifează un singur răspuns sau scrie în spațiul deschis dacă nu regăsești răspunsul în listă',
            'checkbox-free',
            [new Response(1, '1 zi, o singură sesiune de utilizare'),
            new Response(2, '1 zi, dar mai multe sesiuni de utilizare'),
            new Response(3, '2 - 7 zile (maxim o săptămână)'),
            new Response(4, '1 - 2 săptămâni'),
            new Response(5, '3 - 4 săptămâni (maxim o lună)'),
            new Response(6, '1 - 2 luni'),
            new Response(7, '3 - 4 luni'),
            new Response(8, 'Altceva')],
            false
        );

        this.question33.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0 && (this.segment == 'FLOW1' || this.segment == 'FLOW2')) {
                    if (question15SelectedId[0].id >= 7 && question15SelectedId[0].id <= 8) {
                        return true;
                    }
                    return false;
                }


                let question11SelectedId = this.question11.responses.filter(r => r.selected);
                if (question11SelectedId.length > 0 && this.segment == 'FLOW3') {
                    let question11SelectedTexts = this.question11.responses.filter(r => r.selected).map(r => r.text);
                    if (question11SelectedTexts.includes('Ploom')) {
                        return true;
                    }
                    return false;
                }

                return false;
            }
            return false;
        }

        // this.question34 = new Question(35, [15],//13
        //     'Care sunt motivele pentru care nu mai utilizezi dispozitivul Ploom?',
        //     'Bifează toate răspunsurile care se aplică, sau scrie în spațiul deschis dacă nu regăsești răspunsul în listă sau mai ai ceva de adăugat',
        //     'checkbox-free',
        //     [new Response(1, 'Nu mi-a plăcut forma/ design-ul dispozitivului'),
        //     new Response(2, 'Nu mi-a plăcut cum se simte în mână'),
        //     new Response(3, 'Bateria a ținut prea puțin după încărcare'),
        //     new Response(4, 'Durează prea mult încărcarea dispozitivul'),
        //     new Response(5, 'Numărul de sesiuni per încărcare este prea mic'),
        //     new Response(6, 'Numărul de fumuri pe sesiune este prea mic'),
        //     new Response(7, 'Numărul de sesiuni consecutive este prea mic'),
        //     new Response(8, 'Nu am perceput o diferență față de alte dispozitive'),
        //     new Response(9, 'Mi s-a părut complicat de utilizat'),
        //     new Response(10, 'Dispozitivul s-a stricat'),
        //     new Response(11, 'Încălzește stick-urile prea tare'),
        //     new Response(12, 'Dispozitivul nu se găsește ușor în magazine'),
        //     new Response(13, 'Alte motive legate de dispozitiv. Te rugăm descrie motivele ')],
        //     true
        // );

        // this.question34.render = () => {
        //     if (this.endgame == true) { return false; }
        //     if (this.segment != 'STOP') {
        //         let question15SelectedId = this.question15.responses.filter(r => r.selected);
        //         if (question15SelectedId.length > 0 && (this.segment == 'FLOW1' || this.segment == 'FLOW2')) {
        //             if (question15SelectedId[0].id >= 7 && question15SelectedId[0].id <= 8) {
        //                 return true;
        //             }
        //             return false;
        //         }

        //         let question11SelectedId = this.question11.responses.filter(r => r.selected);
        //         if (question11SelectedId.length > 0 && this.segment == 'FLOW3') {
        //             let question11SelectedTexts = this.question11.responses.filter(r => r.selected).map(r => r.text);
        //             if (question11SelectedTexts.includes('Ploom')) {
        //                 return true;
        //             }
        //             return false;
        //         }
        //         return false;
        //     }
        //     return false;
        // }

        // this.question35 = new Question(36, [15],//13
        //     'Care sunt motivele pentru care nu mai utilizezi Sobranie sticks Ploom?',
        //     'Bifează toate răspunsurile care se aplică, sau scrie în spațiul deschis dacă nu regăsești răspunsul în listă sau mai ai ceva de adăugat',
        //     'checkbox-free',
        //     [new Response(1, 'Variantele de intensitate a gustului Sobranie sticks sunt prea slabe (intensitate slabă)'),
        //     new Response(2, 'Variantele de intensitate a gustului Sobranie sticks sunt prea tari (intensitate prea tare)'),
        //     new Response(3, 'Savoarea gustului nu este pe placul meu'),
        //     new Response(4, 'Nu sunt sortimente cu gust caracteristic și nu au arome perceptibile în mod clar cum au produsele din plante cu nicotină'),
        //     new Response(5, 'Sunt prea puține sortimente diferite'),
        //     new Response(6, 'Utilizam prea multe stick-uri'),
        //     new Response(7, 'Sobranie sticks nu se găsesc ușor în magazine'),
        //     new Response(8, 'Se rupeau ușor când le introduceam în dispozitiv'),
        //     new Response(9, 'Alte motive legate de Sobranie sticks. Te rugăm descrie motivele')],
        //     true
        // );

        // this.question35.render = () => {
        //     if (this.endgame == true) { return false; }
        //     if (this.segment != 'STOP') {
        //         let question15SelectedId = this.question15.responses.filter(r => r.selected);
        //         if (question15SelectedId.length > 0 && (this.segment == 'FLOW1' || this.segment == 'FLOW2')) {
        //             if (question15SelectedId[0].id >= 7 && question15SelectedId[0].id <= 8) {
        //                 return true;
        //             }
        //             return false;
        //         }

        //         let question11SelectedId = this.question11.responses.filter(r => r.selected);
        //         if (question11SelectedId.length > 0 && this.segment == 'FLOW3') {
        //             let question11SelectedTexts = this.question11.responses.filter(r => r.selected).map(r => r.text);
        //             if (question11SelectedTexts.includes('Ploom')) {
        //                 return true;
        //             }
        //             return false;
        //         }
        //         return false;
        //     }
        //     return false;
        // }


        this.question36 = new Question(37, [15],//14a
            'Ce ți-a plăcut din experiența Ploom și Sobranie sticks?',
            'Scrie tot ce ți-a plăcut, dacă există ceva. Nu există răspunsuri corecte sau greșite, ne interesează părerea ta sinceră.',
            'free',
            [new Response(1, '')],
            false
        );

        this.question36.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0 && (this.segment == 'FLOW1' || this.segment == 'FLOW2')) {
                    if (question15SelectedId[0].id >= 7 && question15SelectedId[0].id <= 8) {
                        return true;
                    }
                    return false;
                }

                let question11SelectedId = this.question11.responses.filter(r => r.selected);
                if (question11SelectedId.length > 0 && this.segment == 'FLOW3') {
                    let question11SelectedTexts = this.question11.responses.filter(r => r.selected).map(r => r.text);
                    if (question11SelectedTexts.includes('Ploom')) {
                        return true;
                    }
                    return false;
                }
                return false;
            }
            return false;
        }

        this.question37 = new Question(38, [15],//14b
            'Ce îți place din experiența Ploom și Sobranie sticks?',
            'Scrie tot ce apreciezi. Nu există răspunsuri corecte sau greșite, ne interesează părerea ta sinceră. Te rugăm să scrii toate motivele.',
            'free',
            [new Response(1, '')],
            false
        );

        this.question37.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'FLOW3' && this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0) {
                    if (question15SelectedId[0].id >= 1 && question15SelectedId[0].id <= 6) {
                        return true;
                    }
                }
                return false;
            }
            return false;
        }

        this.question38 = new Question(39, [15, 11],
            'Ce îți dorești să se îmbunătățească la experiența Ploom și Sobranie sticks?',
            'Nu există răspunsuri corecte sau greșite, ne interesează părerea ta sinceră. Te rugăm să scrii toate lucrurile pe care le dorești îmbunătățite.',
            'free',
            [new Response(1, '')],
            false
        );

        this.question38.render = () => {
            if (this.endgame == true) { return false; }
            if (this.segment != 'STOP') {
                let question15SelectedId = this.question15.responses.filter(r => r.selected);
                if (question15SelectedId.length > 0 && (this.segment == 'FLOW1' || this.segment == 'FLOW2')) {
                    if (question15SelectedId[0].id >= 1 && question15SelectedId[0].id <= 8) {
                        return true;
                    }
                    return false;
                }

                let question11SelectedId = this.question11.responses.filter(r => r.selected);
                if (question11SelectedId.length > 0 && this.segment == 'FLOW3') {
                    let question11SelectedTexts = this.question11.responses.filter(r => r.selected).map(r => r.text);
                    if (question11SelectedTexts.includes('Ploom')) {
                        return true;
                    }
                    return false;
                }
                return false;
            }
            return false;
        }

        this.question39 = new Question(41, [39],//12 ploom
            'Lucrezi sau ai lucrat în vreunul din domeniile de mai jos?',
            'Bifează tot ce se aplică, sau “Niciunul”',
            'checkbox',
            [new Response(1, 'Producerea / comercializarea / distribuirea produselor din tutun'),
            new Response(2, 'Televiziune, radio'),
            new Response(3, 'Jurnalism'),
            new Response(4, 'Marketing / Cercetare de piață / Publicitate'),
            new Response(5, 'Niciunul')],
            true
        );
        let question39ResponseRendererNone = (rsp: Response): boolean => {
            let question39SelectedTexts = this.question39.responses.filter(r => r.selected).map(r => r.id);
            if (question39SelectedTexts.length > 0) {
                if (question39SelectedTexts.includes(5)) {
                    return true;
                }
                return false;
            }
            return true;
        }
        let question39ResponseRenderer = (rsp: Response): boolean => {
            let question39SelectedTexts = this.question39.responses.filter(r => r.selected).map(r => r.id);
            if (question39SelectedTexts.length > 0) {
                if (!question39SelectedTexts.includes(5)) {
                    return true;
                }
                return false;
            }
            return true;
        }

        this.question39.responses[4].render = question39ResponseRendererNone;
        this.question39.responses[0].render = question39ResponseRenderer;
        this.question39.responses[1].render = question39ResponseRenderer;
        this.question39.responses[2].render = question39ResponseRenderer;
        this.question39.responses[3].render = question39ResponseRenderer;

        this.question39.render = () => {
            if (this.endgame == true) { return false; }
            if (this.getSegment()) {
                return true;
            }
            return false;
            // return true
        }

        this.question40 = new Question(42, [41],//12 ploom
            'Dar rudele apropiate sau prietenii apropiați?',
            'Bifează tot ce se aplică, sau “Niciunul”',
            'checkbox',
            [new Response(1, 'Producerea / comercializarea / distribuirea produselor din tutun'),
            new Response(2, 'Televiziune, radio'),
            new Response(3, 'Jurnalism'),
            new Response(4, 'Marketing / Cercetare de piață / Publicitate'),
            new Response(5, 'Niciunul')],
            true
        );

        let question40ResponseRendererNone = (rsp: Response): boolean => {
            let question40SelectedTexts = this.question40.responses.filter(r => r.selected).map(r => r.id);
            if (question40SelectedTexts.length > 0) {
                if (question40SelectedTexts.includes(5)) {
                    return true;
                }
                return false;
            }
            return true;
        }
        let question40ResponseRenderer = (rsp: Response): boolean => {
            let question40SelectedTexts = this.question40.responses.filter(r => r.selected).map(r => r.id);
            if (question40SelectedTexts.length > 0) {
                if (!question40SelectedTexts.includes(5)) {
                    return true;
                }
                return false;
            }
            return true;
        }

        this.question40.responses[4].render = question40ResponseRendererNone;
        this.question40.responses[0].render = question40ResponseRenderer;
        this.question40.responses[1].render = question40ResponseRenderer;
        this.question40.responses[2].render = question40ResponseRenderer;
        this.question40.responses[3].render = question40ResponseRenderer;

        this.question40.render = () => {
            if (this.endgame == true) { return false; }
            if (this.getSegment()) {
                return true;
            }
            return false;
            // return true;
        }

        this.questions = [this.questionGateAge, this.question1, this.question2, this.question3, this.question4,
        this.disclaimer1, this.question5, this.question6, this.question7, this.question8, this.question9, this.question10,
        this.disclaimer2, this.question11, this.disclaimer3, this.question12, this.question13, this.question14, this.question15, this.question16,
        this.question17, this.question18, this.question19, this.question20, this.question21, this.question22,
        this.question23, this.question24, this.question25, this.question26, this.question27, this.question28,
        this.question29, this.question30a, this.question30b, this.question31, this.question32, this.question33, /*this.question34,*/
        /*this.question35,*/ this.question36, this.question37, this.question38, this.question39, this.question40];

    }

    getQuestions(): Array<Question> {
        return this.questions;
    }

    getFlow(q1: any, q2: any, q3: any, q4: any): any {
        //         FLOW 1 = 1A (any 1-6) + 1B (any 1-6) [RMC + HTS] 

        // FLOW 2 = 1A (any 7-10) + at least one of 1B | 1C | 1D cu o valoare intre 1-6 [non RMC] 

        // FLOW 3 = 1A (any 1-6) + 1B (any 7-10) [RMC & non HTS]
        this.segment = undefined;
        if (q1 != undefined && q1 > 0 && q2 != undefined && q2 > 0 && q3 != undefined && q3 > 0 && q4 != undefined && q4 > 0) {
            if (q1 >= 7 && q1 <= 10 && q2 >= 7 && q2 <= 10 && q3 >= 7 && q3 <= 10 && q4 >= 7 && q4 <= 10) {
                this.segment = 'STOP';
            }

            if (q1 >= 1 && q1 <= 6 && q2 >= 1 && q2 <= 6) {
                this.segment = 'FLOW1';
            }
            if ((q1 >= 7 && q1 <= 10) && (
                (q2 >= 1 && q2 <= 6) || (q3 >= 1 && q3 <= 6) || (q4 >= 1 && q4 <= 6)
            )
            ) {
                this.segment = 'FLOW2';
            }
            if (q1 >= 1 && q1 <= 6 && q2 >= 7 && q2 <= 10) {
                this.segment = 'FLOW3';
            }
        }
        // return this.segment;
    }

    getSegment(): boolean {
        if (this.segment == 'FLOW1' || this.segment == 'FLOW2' || this.segment == 'FLOW3') {
            return true;
        }
        return false;
    }


    question8Responses = [new Response(1, "Camel Filters (galben, scurte)/ Camel Yellow (scurte)"),
    new Response(2, "Camel Filters (galben, lungi)/ / Camel Yellow (lungi)"),
    new Response(3, "Camel Compact negru (lungi)"),
    new Response(4, "Camel Compact albastru (lungi)"),
    new Response(5, "Camel Caster (lungi)"),
    new Response(6, "Camel 1913 Original Filters (galben, cu camila neagra, lungi)"),
    new Response(7, "Camel 1913 Original Blue (albastru deschis, cu camila neagra, lungi)"),
    new Response(8, "Camel 1913 Original Black (negru, cu camila galbena, lungi)"),
    new Response(9, "Davidoff Classic (lungi, normale, pachet rosu inchis)"),
    new Response(10, "Davidoff Gold normale (lungi, pachet auriu)"),
    new Response(11, "Davidoff Gold SL-Line (subtiri, lungi, pachet auriu)"),
    new Response(12, "Davidoff Magenta (subtiri, lungi, pachet mov)"),
    new Response(13, "Davidoff SSL-Line Lilac subtiri (negru cu mici forme geometrice in colturi, lungi)"),
    new Response(14, "Davidoff SSL-Line Rose subtiri (roz, lungi)"),
    new Response(15, "Davidoff Silver normale (argintiu, lungi)"),
    new Response(16, "Davidoff Silver SL-Line (subtiri, lungi, pachet argintiu)"),
    new Response(17, "Davidoff Classic SL-Line subtiri (lungi, pachet rosu inchis)"),
    new Response(18, "Davidoff White subtiri (alb, lungi)"),
    new Response(19, "Davidoff District Negru (normale, lungi, cu filtru negru)"),
    new Response(20, "Davidoff District Gold (subtiri, lungi, cu filtru auriu, pachet auriu cu un colt alb)"),
    new Response(21, "Davidoff Teal (negru cu mici forme geometrice in colturi, tigareta cu filtru verde)"),
    new Response(22, "Dunhill Evoque Blue (lungi, pachet cu mix de nuante de albastru si putin rosu in stanga)"),
    new Response(23, "Dunhill Evoque Bronze (lungi, pachet mix de culori pastelate)"),
    new Response(24, "Dunhill Evoque SS (subtiri, lungi, pachet verde inchis cu o fasie rosu cu maro deschis)"),
    new Response(25, "Dunhill Evoque SS (subtiri, lungi, pachet roz inchis cu o fasie rosu cu maro deschis)"),
    new Response(26, "Dunhill Evoque SS (subtiri, lungi, pachet alb cu o fasie rosu cu maro deschis)"),
    new Response(27, "Dunhill Opus Enigma Black (lungi, pachet negru, tigarete cu filtru negru)"),
    new Response(28, "Dunhill Opus Enigma Blue (lungi, pachet mix nuante de albastru si linii aurii/ flori de gheata)"),
    new Response(29, "Dunhill albastru (lungi, pachet albastru complet)"),
    new Response(30, "Dunhill Blonde Blend (lungi, pachet cu bej deschis si bej inschis)"),
    new Response(31, "Dunhill negru (lungi, albe, pachet negru complet)"),
    new Response(32, "Dunhill alb Fine Cut (lungi, pachet alb complet)"),
    new Response(33, "Dunhill Fine Cut (tigarete negre, lungi, in pachet rosu cu puncte si putin negru)"),
    new Response(34, "Dunhill Signature Turquoise (lungi, pachet turcois)"),
    new Response(35, "Dunhill Signature Purple (lungi, pachet mov)"),
    new Response(36, "Dunhill Signature Black (lungi, tigarete cu filtru negru, pachet negru complet)"),
    new Response(37, "Dunhill Signature White (lungi, pachet alb complet, tigarete cu dunga aurie sau rosie pe filtru)"),
    new Response(38, "Kent Core Black (lungi, pachet negru)"),
    new Response(39, "Kent Core Blue/Kent 8 ( scurte, pachet albastru)"),
    new Response(40, "Kent Core Blue/Kent 8 (lungi, pachet albastru)"),
    new Response(41, "Kent Core Silver (scurte, pachet gri)"),
    new Response(42, "Kent Core Silver (lungi, pachet gri))"),
    new Response(43, "Kent Core White (lungi, pachet alb)"),
    new Response(44, "Kent Mode Blue (lungi, pachet cu albastru deschis si albatsru inchis)"),
    new Response(45, "Kent Mode Silver (lungi, pachet cu gri si albastru)"),
    new Response(46, "Kent Mode Lumina (lungi, pachet negru cu model fagure albastru)"),
    new Response(47, "Kent Mode Eklipse Burgundy (subtiri, pachet cu visiniu)"),
    new Response(48, "Kent Mode Eklipse Sage Green (subtiri, pachet verde inchis cu verde mai deschis)"),
    new Response(49, "Kent Mode Komet Azure (lungi, pachet albastru deschis cu albastru azur si stelute in stanga)"),
    new Response(50, "Kent Mode Komet Blue (lungi, pachet albastru deschis cu albastru inchis si stelute in stanga)"),
    new Response(51, "Kent Mode Komet Navy Blue (lungi, pachet albastru inchis cu stelute in stanga)"),
    new Response(52, "Kent Nano Silver (subtiri, scurte, in pachet negru cu model de romburi mici)"),
    new Response(53, "Kent Nano White (subtiri, scurte, in pachet negru cu gri si model de romburi mici)"),
    new Response(54, "Kent lungi, fostul pachet necartonat/ pachet alb cu castel"),
    new Response(55, "Lucky Strike alb cu bulina rosie ( scurte)"),
    new Response(56, "Marlboro Gold scurte"),
    new Response(57, "Marlboro Gold lungi"),
    new Response(58, "Marlboro rosu lungi"),
    new Response(59, "Marlboro rosu scurte"),
    new Response(60, "Marlboro Filter Plus (lungi)"),
    new Response(61, "Marlboro Filter Plus ( scurte)"),
    new Response(62, "Marlboro Fine Touch albastru deschis ( scurte)"),
    new Response(63, "Marlboro Fine Touch XL albastru deschis (lungi)"),
    new Response(64, "Marlboro Gold Touch XL (pachet cu auriu)"),
    new Response(65, "Marlboro Red Touch XL (pachet negru)"),
    new Response(66, "Marlboro Touch albastru inchis ( scurte)"),
    new Response(67, "Marlboro Touch Plus XL (pachet albastru deschis, lungi)"),
    new Response(68, "Marlboro Touch XL albastru inchis (lungi)"),
    new Response(69, "Marlboro Micro Touch Green (subtiri, pachet verde)"),
    new Response(70, "Marlboro Micro Fine Touch albastru deschis (subtiri)"),
    new Response(71, "Marlboro Micro Touch albastru inchis (subtiri)"),
    new Response(72, "Pall Mall albastru (scurte, in pachet albastru-inchis cu 2 dungi albastru-deschis in mijloc)"),
    new Response(73, "Pall Mall Extra Cut Blue (lungi, pachet gri-inchis cu 2 dungi albastru-deschis in mijloc)"),
    new Response(74, "Pall Mall Extra Cut White (lungi, pachet gri cu 2 dungi gri-deschis in mijloc)"),
    new Response(75, "Pall Mall Extra Cut Black (lungi, pachet negru cu 2 dungi albastru-inchis in mijloc)"),
    new Response(76, "Pall Mall S-Line Purple (subtiri, pachet mov deschis)"),
    new Response(77, "Pall Mall S-Line Rose (subtiri, pachet roz deschis)"),
    new Response(78, "Pall Mall S-Line turcoaz (subtiri, pachet turcoaz)"),
    new Response(79, "Pall Mall Ascend Black (lungi, pachet negru cu 2 dungi negre la mijloc, tigarete cu filtru negru)"),
    new Response(80, "Pall Mall Ascend Rose Gold (lungi, pachet bej cu 2 dungi maro la mijloc, tigarete cu filtru bej)"),
    new Response(81, "Parliament Aqua Blue lungi"),
    new Response(82, "Parliament Aqua Blue scurte"),
    new Response(83, "Parliament Reserve Premium (subtiri, lungi)"),
    new Response(84, "Parliament Manhattan NYC Night (albastru inchis)"),
    new Response(85, "Parliament Manhattan NYC Aqua (albastru deschis)"),
    new Response(86, "Rothmans - alb cu albastru"),
    new Response(87, "Rothmans Classic Blue (lungi, pachet albastru-inchis)"),
    new Response(88, "Rothmans Classic Black (lungi, pachet negru)"),
    new Response(89, "Rothmans Classic Red (lungi, pachet rosu)"),
    new Response(90, "Rothmans Classic Azure (lungi, pachet albastru-deschis)"),
    new Response(91, "Rothmans International Black (subtiri, pachet negru, tigarete cu filtru negru)"),
    new Response(92, "Rothmans International Blue (subtiri, pachet albastru, tigarete cu filtru albastru)"),
    new Response(93, "Sobranie Black (scurte, pachet negru)"),
    new Response(94, "Sobranie Redefined Black (negru, lungi)"),
    new Response(95, "Sobranie Redefined Blue (albastru, lungi)"),
    new Response(96, "Sobranie Redefined Chrome (gri, lungi)"),
    new Response(97, "Sobranie Redefined White (alb, lungi)"),
    new Response(98, "Sobranie Redefined Rosu (pachet negru cu rosu)"),
    new Response(99, "Sobranie Super S Black (subtiri, pachet negru, tigarete albe)"),
    new Response(100, "Sobranie Super S Pink (subtiri, pachet roz)"),
    new Response(101, "Sobranie Super S White (subtiri, pachet alb)"),
    new Response(102, "Sobranie Super S Cocktail (subtiri, pachet roz deschis, tigarete colorate)"),
    new Response(103, "Sobranie Super S Christmas (subtiri, pachet negru cu puncte aurii)"),
    new Response(104, "Sobranie Collection negru (subtiri, lungi, pachet lat negru, tigarete albe, filtru negru)"),
    new Response(105, "Sobranie Collection Gold (subtiri, lungi, pachet lat roz si alb, tigarete cu filtru auriu)"),
    new Response(106, "Sobranie Collection alb (subtiri, lungi, pachet lat alb, tigarete cu filtru auriu)"),
    new Response(107, "Sobranie Collection Red (subtiri, lungi, pachet lat negru cu rosu, tigarete negre)"),
    new Response(108, "Sobranie Collection Lumia (subtiri, lungi, pachet lat crem cu maro, tigarete cu filtru maro)"),
    new Response(109, "Sobranie Collection albastru (subtiri, lungi, pachet lat negru cu albastru, tigarete cu filtru albastru)"),
    new Response(110, "Vogue La cigarette Bleue (subtiri, lungi, pachet mov)"),
    new Response(111, "Vogue La cigarette Ivoire (subtiri, lungi, pachet crem)"),
    new Response(112, "Vogue La cigarette Lilas (subtiri, lungi, pachet roz)"),
    new Response(113, "Vogue La cigarette Bleue Unique (subtiri, lungi, pachet negru, tigarete cu filtru albastru-deschis)"),
    new Response(114, "Vogue La cigarette Rose Unique (subtiri, lungi, pachet negru, tigarete cu filtru roz)"),
    new Response(115, "Winston Blue lungi (pachet alb cu albastru)"),
    new Response(116, "Winston Blue scurte (pachet alb cu albastru)"),
    new Response(117, "Winston Classic rosu (lungi)"),
    new Response(118, "Winston Classic rosu ( scurte)"),
    new Response(119, "Winston Silver (scurte, pachet alb cu gri)"),
    new Response(120, "Winston Super Line Blue (subtiri, pachet alb cu puncte albastre in stanga)"),
    new Response(121, "Winston Super Line Silver (subtiri, pachet alb cu puncte albastre in stanga)"),
    new Response(122, "Winston Caster Super Line (subtiri, lungi, pachet auriu inchis)"),
    new Response(123, "Winston Nova Blue (lungi, pachet albastru complet cu puncte albastre)"),
    new Response(124, "Winston Nova Gold (lungi, pachet auriu cu puncte aurii)"),
    new Response(125, "Winston Plus Red (lungi, pachet negru cu puncte gri inchis)"),
    new Response(126, "Winston XSpression (lungi, pachet albastru deshis si albastru inchis)"),
    new Response(127, "Winston Xspression Super Line (subtiri, lungi, pachet alb cu albastru deschis)"),
    new Response(128, "Winston Caster (lungi, pachet alb cu aramiu dungi si puncte aramii)"),
    new Response(129, "Winston Selection Night (lungi, maro inchis)"),
    new Response(130, "Winston Selection Sunrise (lungi, verde inchis)"),
    new Response(131, "Winston Selection Sunset (lungi, portocaliu inchis)"),
    new Response(132, "Winston Selection Skylite (lungi, albastru cu o parte portocalie)"),
    new Response(133, "Alta marca (Scrie)")];


}

